import React from 'react';

interface StrategyModuleProps {
  user: {
    name: string;
    email: string;
    account: any;
  } | null;
}

const StrategyModule: React.FC<StrategyModuleProps> = ({ user }) => {
  return (
    <div style={{
      width: '100%',
      height: 'calc(100vh - 70px)',
      background: '#FFFFFF',
      overflow: 'hidden'
    }}>
      <iframe
        src="/marketing_strategy.html"
        title="Portal MVP Plan"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
    </div>
  );
};

export default StrategyModule;
